module.exports = __webpack_public_path__ + "img/person.dd6a7266.png";